export { SmoothScrollService, SmoothScrollOptions } from './smooth-scroll.service';